// @ts-nocheck: converted from JS

import Tasks from '@/components/Tasks/Show';

export default Tasks;
